import modalStyle from '../org-management-modal.module.scss';

import { Row, Col } from 'react-bootstrap';

import Input from 'components/Input';
import Button from 'components/Button';
import ModalContainer from 'components/ModalContainer';
import DropdownWithItem from 'components/DropdownWithItem';
import DropdownWithCheckbox from "components/DropdownWithCheckbox";
import MessageBoxGroup from 'components/MessageBoxGroup';
import SpinnerForModal from "ui/SpinnerForModal";

import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';

import { uiActions, selectShowModalSpinner } from "stores/slice/ui";
import { organizationType } from 'const/nuclias/organization';
import { userType, userPrivilege } from 'const/nuclias/user';

import AuthUserService from 'services/Auth.User.service';

import { cloneDeep, isNil, orderBy, size } from 'lodash';
import validator from "validator";

import { defaultMessages } from "../const";
import modalController from "./modalController"

const defaultRoleList = [
  { title: 'e3afed0047', value: userPrivilege.manager, isActive: true },
  { title: '344a7f427f', value: userPrivilege.editor, isActive: false },
  { title: 'd2986ac8cb', value: userPrivilege.monitor, isActive: false },
  { title: 'fb15c53f22', value: userPrivilege.viewer, isActive: false },
];

const defaultModalData = {
  name: {
    value: '',
    isInvalid: false
  },
  email: {
    value: '',
    isInvalid: false
  },
  privilege: {},
  selectedTag: {},
  selectedSite: {},
}

const defaultAccessList = {
  [organizationType.sp]: [{ title: 'e1b3ec89ea' }],
  [organizationType.si]: [{ title: 'MSP' }],
  [organizationType.org]: [{ title: 'c1ca926603' }]
}

const OrgManagementInviteUser = ({
  info,
  modalStatus,
  handleModals,
  submitModal
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const showModalSpinner = useSelector(selectShowModalSpinner);
  const { pageContext } = useSelector((store) => store);
  const targetInfo = {
    orgName: modalStatus.invite.editObj.name || modalStatus.invite.editObj.orgName,
    employerId: modalStatus.invite.editObj.id || modalStatus.invite.editObj.orgId,
    type: modalStatus.invite.editObj.orgType,
  }
  const [multiMessages, setMultiMessages] = useState(cloneDeep(defaultMessages));
  const [modalInfo, setModalInfo] = useState({});
  const [modalData, setModalData] = useState(cloneDeep(defaultModalData));
  const [options, setOptions] = useState({ role: [], orgList: [], siList: [], siteList: [] }); // site: tag>site

  const init = async () => {
    try {
      dispatch(uiActions.showModalSpinner());
      await initOptions()
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(uiActions.hideModalSpinner());
    }
  }

  const initOptions = async () => {
    const optionsTmp = {
      role: cloneDeep(defaultRoleList),
      orgList: [{ title: targetInfo.orgName }],
      tagList: [],
      siteList: []
    }
    if (targetInfo.type === organizationType.sp) {
      optionsTmp.siList = modalController.genSiList()
    } else if (targetInfo.type === organizationType.si) {
      // tmp
    } else {
      let orgObj = null
      if (info.userType === userType.org) {
        orgObj = { selectedOrg: pageContext.selectedOrg, orgTreeMap: pageContext.orgTreeMap }
      } else {
        orgObj = await modalController.getSelectedOrg({ id: targetInfo.employerId })
      }
      setModalInfo({ ...modalInfo, ...orgObj })
      const { tagList, siteList } = await modalController.getDefaultSiteList(orgObj)
      optionsTmp.tagList = tagList
      optionsTmp.siteList = siteList

    }
    const copyData = cloneDeep(modalData)
    copyData.privilege = defaultRoleList[0]
    copyData.selectedTag = optionsTmp.tagList[0] || {}
    copyData.selectedSite = optionsTmp.siteList[0] || {}
    setModalData(copyData)
    setOptions(optionsTmp)
  }

  const changeRole = (target) => {
    const copy = cloneDeep(defaultRoleList)
    for (const item of copy) {
      item.isActive = item.value === target.value ? true : false
    }
    setOptions({ ...options, role: copy })
    setModalData({ ...modalData, privilege: target })
  }

  const changeMSP = (target) => {
    const newSiLIst = modalController.changeCheckedMSP(target, options.siList)
    setOptions({ ...options, siList: newSiLIst })
  }

  const changeTag = (target) => {
    const { targets, copyList } = modalController.changeCheckedTag(target, options, modalInfo)
    setModalData({ ...modalData, ...targets })
    setOptions(copyList)
  }

  const changeSite = (target) => {
    const copy = cloneDeep(options.siteList)
    copy.map(function (item) {
      item.checked = item.value === target.value ? true : false
      return item
    });
    setModalData({ ...modalData, selectedSite: target })
    setOptions({ ...options, siteList: copy })
  }

  const changeRequired = (key, value) => {
    const copy = cloneDeep(modalData)
    copy[key].value = value
    copy[key].isInvalid = checkInvalid(key, value)
    setModalData(copy)
  }

  const checkInvalid = (key, value = '') => {
    let res = true;
    // const target = modalData[key]
    switch (key) {
      case 'name':
        res = validator.isLength(value, { min: 1, max: 64 })
        break
      case 'email':
        res = validator.isEmail(value) && validator.isLength(value, { min: 1, max: 128 })
        break
      case 'siList':
        const list = modalController.getCheckedMSP(targetInfo, options.siList)
        res = size(list) > 0 ? true : false
        break
      default:
        res = true
    }
    return !res
  }

  const checkFormInvalid = () => {
    const checkList = [
      { key: 'name', value: true },
      { key: 'email', value: true },
    ]
    if (targetInfo.type === organizationType.sp) {
      checkList.push({ key: 'siList' })
    }
    let res = false
    for (const item of checkList) {
      const value = item.key ? modalData[item.key]?.value : null
      if (checkInvalid(item.key, value)) {
        res = true;
        break;
      }
    }
    return res
  }

  const formatData = () => {
    const tmp = {
      name: modalData.name.value,
      email: modalData.email.value,
      employerId: targetInfo.employerId,
      privilege: modalData.privilege.value
    }
    if (targetInfo.type === organizationType.sp) {
      tmp.resources = modalController.getCheckedMSP(targetInfo, options.siList)
      tmp.type = userType.sp
    } else if (targetInfo.type === organizationType.si) {
      tmp.resources = [{ id: targetInfo.employerId, type: organizationType.si }]
      tmp.type = userType.si
    } else {
      const { newType, resources } = modalController.getCheckedSite(targetInfo, modalData)
      tmp.type = newType
      tmp.resources = resources
    }
    return tmp
  }

  const submit = () => {
    try {
      dispatch(uiActions.showModalSpinner());
      const obj = formatData()
      // console.log('obj', obj)
      const res = AuthUserService.postInviteUser(obj)
      if (res.error) {
        const copy = cloneDeep(defaultMessages)
        copy.error = res.error.code
        setMultiMessages(copy);
      } else {
        submitModal({ reload: true })
        closeModal()
      }
    } catch (error) {
      console.debug(error)
      dispatch(uiActions.hideModalSpinner());
    }
  }

  const closeModal = () => {
    handleModals({ modal: 'invite', status: false })
  }

  useEffect(() => {
    init();
  }, [modalStatus.invite?.status]);

  return (
    <ModalContainer
      modalWidthType='modal-500px'
      openModal={modalStatus.invite.status}
      closeModal={() => closeModal()}
    >
      {showModalSpinner && <SpinnerForModal />}
      <div className='header'>
        <div className='title'>{t('440a99b2ea')}</div>
      </div>
      <div className={`body ${modalStyle['invite-user-container']}`}>
        <MessageBoxGroup
          messages={multiMessages}
          ErrorMessagesType='es'
          WarningMessagesType='i18n'
          onClose={type => setMultiMessages({ ...multiMessages, [type]: null })}
        />

        <div className='modal-form-title required'>{t('49ee308734')}</div>
        <div className='modal-form-field'>
          <Input
            value={modalData.name.value}
            placeholder={t('9fa545e2cd')}
            onChange={(e) => changeRequired('name', e.target.value)}
            isInvalid={modalData.name?.isInvalid}
          />
        </div>

        <div className='modal-form-title required'>{t('b357b524e7')}</div>
        <div className='modal-form-field'>
          <Input
            value={modalData.email.value}
            placeholder={t('ca5977f4f2')}
            onChange={(e) => changeRequired('email', e.target.value)}
            isInvalid={modalData.email?.isInvalid}
          />
        </div>
        <div className={modalStyle['email-hint']}>{t('9d537af410')}</div>
        <div className='form-subtitle my-3'>{t('8f1bd444d2')}</div>

        <div className='modal-form-title required'>{t('727b677950')}</div>
        <div className='modal-form-field'>
          <DropdownWithItem
            id="privilege-term-dropdown"
            type="normal"
            selectedItem={modalData?.privilege || {}}
            itemList={options?.role || []}
            onClick={(item) => { changeRole(item) }}
            disabled={targetInfo.type === organizationType.sp}
          />
        </div>

        {/* Access level */}
        <div className='modal-form-title required mt-2'>{t('de88250cdc')}</div>
        <Row>
          <Col>
            <div className='modal-form-field'>
              <DropdownWithItem
                id="access-level-dropdown"
                type="normal"
                selectedItem={defaultAccessList[targetInfo.type][0] || {}}
                itemList={defaultAccessList[targetInfo.type]}
                disabled
              />
            </div>
          </Col>
          <Col>
            <DropdownWithItem
              id="access-level-sub-dropdown"
              type="normal"
              selectedItem={options?.orgList[0] || {}}
              itemList={options?.orgList || []}
              disabled
            />
          </Col>
        </Row>
        {
          targetInfo.type === organizationType.sp &&
          <>
            <div className='form-title my-3'>{t('Managed MSP')}</div>
            <div className='modal-form-field'>
              <DropdownWithCheckbox
                id="privilege-term-dropdown"
                type="checkbox"
                itemList={options.siList}
                onChange={(item) => { changeMSP(item) }}
              // isInvalid={checkInvalid('siList')}
              // dropDownMenuStyle={{ maxHeight: '300px', overflow: 'auto' }}
              />
            </div>
          </>
        }

        {
          targetInfo.type === organizationType.si &&
          <>
            <div className='form-title my-3'>{t('31de740e0b')}</div>
            <div className='ps-2'>{t('b1c94ca2fb')}</div>
          </>
        }

        {
          (targetInfo.type !== organizationType.sp && targetInfo.type !== organizationType.si) &&
          <>
            <div className='form-title my-3'>{t('199e0bdbbb')}</div>
            <Row>
              <Col>
                <DropdownWithItem
                  id="manage-tag-dropdown"
                  type="normal"
                  selectedItem={modalData?.selectedTag || {}}
                  itemList={options?.tagList || []}
                  dropDownMenuStyle={{ maxHeight: '300px', overflow: 'auto' }}
                  onClick={(item) => { changeTag(item) }}
                />
              </Col>
              <Col>
                <DropdownWithItem
                  id="manage-site-dropdown"
                  type="normal"
                  selectedItem={modalData?.selectedSite || {}}
                  itemList={options?.siteList || []}
                  dropDownMenuStyle={{ maxHeight: '300px', overflow: 'auto' }}
                  onClick={(item) => { changeSite(item) }}
                />
              </Col>
            </Row>
          </>
        }
      </div>
      <div className='footer'>
        <Button
          label='4a53b84974'
          className='btn-cancel'
          onClick={closeModal}
        />
        <Button
          label='a4d3b161ce'
          className='btn-submit'
          onClick={submit}
          disabled={checkFormInvalid()}
        />
      </div>
    </ModalContainer>
  );
};

export default OrgManagementInviteUser;
